<template>
    <div class="data_select">
            <div class="problem">
                <div class="problem_title">各BG/AMC占比</div>
            </div>
            <div class="data_select_box" v-for="item in dep_result" :key="item.dep_id">
                <div class="data_select_ensure">
                    <span style="margin-left:15px">{{item.dep_name}}</span>
                </div>
                <div class="data_select_text">
                    {{item.user_cnt}}人 {{isNaN((item.user_cnt/done_cnt*100).toFixed(2)) ? 0:(item.user_cnt/done_cnt*100).toFixed(2)}}%
                </div>
            </div>
    </div>
</template>

<script>
import numberToLetter from '../../../../utils/NumberToLetter'
export default {
  props: {
    title: {
      type: String
    },
    options: {
      type: Array
    },
    question_id: {
      type: Number
    },
    done_cnt: {
      type: Number
    },
    index: {
      type: Number
    },
    survey_total_cnt: {
      type: Number
    },
    dep_result: {
      type: Array
    }
  },
  methods: {
    setNumberToLetter (num) {
      return numberToLetter(num)
    }
  }
}
</script>

<style lang='scss' scoped>
.data_select{
        background: #fff;
        width: 91.47%;
        margin: 10px auto;
        padding: 5px 0;
        border-radius: 12px;
        .data_select_box{
            margin: 10px auto;
            width: 91.47%;
            height: 30px;
            line-height: 30px;
            display: flex;
            justify-content: space-between;
            background-color: #e7edf5;
            border-radius: 6px;
            position: relative;
            .data_select_ensure{
                width: 100%;
                background-color: #19cca0;
                border-radius: 6px;
            }
            .data_select_text{
                position: absolute;
                margin-left: 60%;
                width: 40%;
                text-align: end;
            }
        }
        .problem{
            width: 91.47%;
            margin: 10px auto;
            .problem_title{
                font-weight: 500;
                margin-bottom: 5px;
            }
            .proble_select{
                margin: 2px 0;
                font-size: 14px;
            }
        }
    }
</style>
